export default __webpack_public_path__ + "static/highlight-pattern-29d90646d69ef4833fec868c7dba1667.svg";